((window, $, Formio) => {
    let OriginalProvider;
    function UrlStorageProvider(formio, maxUploadChunkSizeBytes) {
        this.formio = formio;
        this.originalProvider = new OriginalProvider(formio);
        this.maxUploadChunkSizeBytes = maxUploadChunkSizeBytes;
    }

    UrlStorageProvider.prototype.deleteFile = function _deleteFile(fileInfo, options) {
        return this.originalProvider.deleteFile(fileInfo, options);
    };

    UrlStorageProvider.prototype.downloadFile = function _downloadFile(file, options) {
        return this.originalProvider.downloadFile(file, options);
    };

    UrlStorageProvider.prototype.uploadFile = function _uploadFile(
        file,
        name,
        dir,
        progressCallback,
        uploadUrl,
        options,
        fileKey,
        groupPermissions,
        groupId,
        abortCallback) {
        const self = this;
        function uploadRequest(form) {
            return new Promise((resolve, reject) => {
                const token = self.formio.getToken();
                $.chunkedFileUpload(
                    file,
                    uploadUrl,
                    {
                        name,
                        dir,
                    },
                    self.maxUploadChunkSizeBytes,
                    crypto.randomUUID(),
                    {
                        fileKey: fileKey,
                        query: {
                            baseUrl: encodeURIComponent(self.formio.projectUrl),
                            project: form?.project || '',
                            // We must use _id to create compatible request. See original source code:
                            // https://github.com/formio/formio.js/blob/3c1c2443bf2278a21c65527adda24637bfa1537f/src/providers/storage/url.js#L89.
                            // eslint-disable-next-line no-underscore-dangle
                            form: form?._id || '',
                        },
                        headers: token ? { 'x-jwt-token': token } : undefined,
                        uploadProgress: progressCallback,
                        abortUpload: abortCallback,
                    })
                    .then((response) => {
                        const result = {
                            storage: self.name,
                            name: name,
                            url: response.url,
                            size: file.size,
                            type: file.type,
                            data: {
                                baseUrl: self.formio.projectUrl,
                                project: form?.project || '',
                                // We must use _id to create compatible result. See original source code:
                                // https://github.com/formio/formio.js/blob/3c1c2443bf2278a21c65527adda24637bfa1537f/src/providers/storage/url.js#L99.
                                // eslint-disable-next-line no-underscore-dangle
                                form: form?._id || '',
                                ...response,
                            },
                        };

                        resolve(result);
                    })
                    .catch((e) => {
                        reject(new Error(`Unable to upload file - ${e.responseJSON.message}`));
                    });
            });
        }

        if (!this.maxUploadChunkSizeBytes) {
            return new Promise((resolve, reject) => {
                this.originalProvider.uploadFile(
                    file,
                    name,
                    dir,
                    progressCallback,
                    uploadUrl,
                    options,
                    fileKey,
                    groupPermissions,
                    groupId,
                    abortCallback)
                    .then((response) => {
                        if (response.data.status === 'error') {
                            reject(response.data.message);
                        }
                        else {
                            const result = {
                                storage: self.name,
                                name: response.name,
                                url: response.data.url,
                                size: file.size,
                                type: file.type,
                                ...response,
                            };
                            result.url = response.data.url;
                            resolve(result);
                        }
                    });
            });
        }

        if (file.private && this.formio.formId) {
            return this.formio.loadForm().then(uploadRequest);
        }

        return uploadRequest();
    };

    UrlStorageProvider.prototype.title = 'Url';
    UrlStorageProvider.prototype.name = 'url';
    UrlStorageProvider.title = 'Url';

    function initialize(maxUploadChunkSizeBytes) {
        if (OriginalProvider) {
            // Already initialized.
            return;
        }

        Formio.setBaseUrl(window.location.origin);

        OriginalProvider = Formio.Providers.providers.storage.url;

        const urlStorageProviderInitializer = function url(formio) {
            return new UrlStorageProvider(formio, maxUploadChunkSizeBytes);
        };

        urlStorageProviderInitializer.title = UrlStorageProvider.title;

        Formio.Providers.providers.storage.url = urlStorageProviderInitializer;
    }

    window.formIoUrlStorageProvider = {
        initialize,
    };
})(window, jQuery, window.Formio);
